import Vue from 'vue'
import parser from 'ua-parser-js'
import {serv, paymentStatus} from '@/api/config'

const ua = parser()
export default new Vue({
  data: {
    isStandalone: !!process.env.VUE_APP_STANDALONE,
    useTutorial: Boolean(process.env.VUE_APP_USE_TUTORIAL),
    Path: serv,
    mobile: {
      iOS: process.env.VUE_APP_DOWNLOAD_IOS_MANAGER,
      Android: process.env.VUE_APP_DOWNLOAD_ANDROID_MANAGER
    },
    Sidebar: ua.device.type !== 'mobile' && ua.device.type !== 'tablet',
    Info: {
      timezone: 'Asia/Seoul',
      timezoneOffset: '540 minutes',
      timezoneOffsetLocal: '0 minutes',
      dateFmt: 'YYYY/MM/DD'
    },
    summary: {},
    ticketSummary: {},
    license: null,
    perm: {
      isAdmin: false,
      isApprover: false,
      isSubManager: false,
      deviceMonitor: null,
      modifyInformation: null,
      useFunction: null,
      viewReport: null,
      CSRemoteControl: null,
      CSDeviceManagement: null,
      CSFileManager: null,
      CSRemoteView: null,
      CSUpdate: null,
      CSThumbnailView: null,
      CSRestart: null
    },
    isMobile: ua.device.type === 'mobile' || ua.device.type === 'tablet',
    isTablet: ua.device.type === 'tablet',
    // 주의: store.get()은 import 시점에 호출하면 안됨 (IndexedDB 초기화 전)
    // main.js의 initializeFromStore()에서 초기화됨
    isApplication: false,
    isCorporate: null,
    isAdmin: null,
    isApprover: null,
    isSubManager: null,
    platform: ua.device.type,
    os: ua.os.name,
    ua: ua,
    paymentState: paymentStatus,
    lang: 'ko',
    env: process.env,
    viewMode: 'normal'
  },
  methods: {
    setSummary (summ) {
      this.summary = summ
    },
    setTicketSummary (summ) {
      this.ticketSummary = summ
    },
    /**
     * IndexedDB 초기화 완료 후 store에서 값을 로드
     * main.js에서 store.waitForInitialization() 후 호출됨
     */
    initializeFromStore (store) {
      this.isApplication = store.get('LMM_MOBILE_APPLICATION') || false
      this.viewMode = store.get('viewMode') || 'normal'
    }
  }
})
